import { IEvent } from "@Interfaces";
import { LISTING_TYPES } from "repoV2/constants/listing";
import { isInstallmentPaymentType } from "repoV2/utils/common/listing";
import { IInstalment } from "../components/PaymentPlan/IPaymentPlan";

/**
 * The original price of the listing. It will contain the initial price for ALL currencies.
 *
 * Note: `price_per_head` will contain the initial price for ALL currencies.
 * No need to use the value of `price_per_head_usd`.
 */
export const getPricePerHead = ({
    eventData,
    selectedPaymentType,
    initialInstalment,
}: {
    eventData: IEvent.IEventData;
    selectedPaymentType?: number;
    initialInstalment?: IInstalment;
}): number => {
    const { type, variantsData, selectedOfferingVariation } = eventData;
    const isMerchandiseListing = type === LISTING_TYPES.MERCHANDISE;
    const hasVariants = !!variantsData?.variants;

    if (isMerchandiseListing && hasVariants)
        return eventData?.selectedVariant?.price_per_head || 0;

    if (isInstallmentPaymentType(selectedPaymentType) && initialInstalment) {
        const { discount_applied = 0, installment_price_final } =
            initialInstalment;
        return installment_price_final - discount_applied;
    }

    if (selectedOfferingVariation) {
        return selectedOfferingVariation?.variant_price_final;
    }

    return eventData?.price_per_head || 0;
};
